import React from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/loginstyles.css';

export default function Login() {
  const initialState = {
    Username: {
      usernameInput: localStorage.getItem('username') || '',
      usernameInputFOUT: false,
      userNameError: ""
    },
    Password: {
      PasswordInput: localStorage.getItem('password') || '',
      PasswordInputFOUT: false,
      passwordError: ""
    }
  };
  
  const [state, setState] = useState(initialState);
  const navigate = useNavigate();

  function handleUsernameInput(event) {
    setState(prevState => ({
      ...prevState,
      Username: { ...prevState.Username, usernameInput: event.target.value, usernameInputFOUT: false, userNameError: "" }
    }));
  }

  function handlePasswordInput(event) {
    setState(prevState => ({
      ...prevState,
      Password: { ...prevState.Password, PasswordInput: event.target.value, PasswordInputFOUT: false, passwordError: "" }
    }));
  }

  async function handleLoginButton(event) {
    event.preventDefault(); 

    const { usernameInput } = state.Username;
    const { PasswordInput } = state.Password;
    let hasError = false;

    if (!usernameInput) {
      setState(prevState => ({
        ...prevState,
        Username: { ...prevState.Username, userNameError: "Please fill in the username field.", usernameInputFOUT: true }
      }));
      hasError = true;
    }

    if (!PasswordInput) {
      setState(prevState => ({
        ...prevState,
        Password: { ...prevState.Password, passwordError: "Please fill in the password field.", PasswordInputFOUT: true }
      }));
      hasError = true;
    }

    if (hasError) {
      return;
    }

    try {
      const response = await fetch(`https://s-backend-rebuild-production.up.railway.app/api/Login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: usernameInput,
          password: PasswordInput,
        }),
        
      });

      console.log('Response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json(); 
        throw new Error(errorData.message || 'Login failed');
      }
      
      const data = await response.json();
      console.log('Response data:', data); 
      console.log('Token:', data.token); 

      if (!data.token) {
        throw new Error('Token not found in response');
      }

      localStorage.setItem('username', usernameInput);
      localStorage.setItem('token', data.token); 
      navigate('/admin'); 

    } catch (error) {
      setState(prevState => ({
        ...prevState,
        Username: { ...prevState.Username, userNameError: error.message, usernameInputFOUT: true },
        Password: { ...prevState.Password, passwordError: error.message, PasswordInputFOUT: true }
      }));
    }
  }

  return (
    <div className="LoginContainer">
      <div className="FormWrapper">
        <Form onSubmit={handleLoginButton}>
          <Form.Control
            className="LoginPageInputField"
            isInvalid={state.Username.usernameInputFOUT}
            onChange={handleUsernameInput}
            value={state.Username.usernameInput}
            type="text" 
            placeholder="Gebruikersnaam"
          />
          <Form.Control.Feedback className="FeedbackOpInput" type="invalid">
            {state.Username.userNameError}
          </Form.Control.Feedback>
          <Form.Control
            className="LoginPageInputField"
            isInvalid={state.Password.PasswordInputFOUT}
            onChange={handlePasswordInput}
            value={state.Password.PasswordInput}
            type="password"
            placeholder="Password"
          />
          <Form.Control.Feedback className="FeedbackOpInput" type="invalid">
            {state.Password.passwordError}
          </Form.Control.Feedback>
          <Button className="ButtonLoginPage" type="submit" variant="primary">
            Log in
          </Button>
        </Form>
      </div>
    </div>
  );
}